import { Injectable } from '@angular/core';
import { CatalogSearchCriteriaType } from './constants/catalog-search-criteria-type.constant';

@Injectable({
  providedIn: 'root',
})
export class CatalogSearchCriteriaService {
  private readonly searchCriteriaStorageKeyPostfix = 'CriteriaType';

  getCatalogSearchCriteriaFromStorage<T>(type: CatalogSearchCriteriaType): T {
    const storageKey = `${type}${this.searchCriteriaStorageKeyPostfix}`;

    const searchCriteriaJson = localStorage.getItem(storageKey);
    const searchCriteria = JSON.parse(searchCriteriaJson);

    return searchCriteria;
  }

  setCatalogSearchCriteriaToStorage(type: CatalogSearchCriteriaType, catalogSearchCriteria: unknown): void {
    const storageKey = `${type}${this.searchCriteriaStorageKeyPostfix}`;

    const searchCriteriaJson = JSON.stringify(catalogSearchCriteria);
    localStorage.setItem(storageKey, searchCriteriaJson);
  }
}
